// extracted by mini-css-extract-plugin
export default {"inputStyle":"inputCellRender_inputStyle__DUvq0"};